import { inject } from '@angular/core';
import { RunInput, SessionStore } from '../../../state';

export class RunCommandHandler {
  private readonly store: SessionStore = inject(SessionStore);

  add(instanceId: string, input: RunInput): void {
    this.store.addRun(instanceId, input);
  }

  update(runId: string, input: RunInput): void {
    this.store.updateRun(runId, input);
  }

  delete(runId: string): void {
    this.store.deleteRun(runId);
  }
}
